import React, { useState, useRef, useEffect } from "react";
import { AiOutlineSearch, AiOutlineClose } from "react-icons/ai";
import products from "../utils/products.png";
import { AiFillDelete } from "react-icons/ai";
import delete_Vector from "../utils/delete_Vector.jpg";
import group from "../utils/group.svg";
import expand from "../utils/expand.png";
import KanbanViewLeads from "./Kanaban";
import axios from "axios";
import LeadStatusModal from "../modals/LeadStatusModal";
import LeadDeleteModal from "../modals/LeadDeleteModal";
import LeadSelectModal from "../modals/LeadSelectModal";
import LeadFilterModal from "../modals/LeadFilterModal";
import filter from "../utils/filter.png";
import { format } from "date-fns";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import ViewLead from "../modals/ViewLead";
import TableGrouped from "./TableGrouped";

import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ButtonGroup,
} from "@mui/material";

import kanban from "../utils/kanban.png";
import table from "../utils/mainTable.svg";

const TableComponent = ({ rows, setRows, groupedRows, onEditLead, onEditLeadFromViewLead, clickedOnEditLead, setValue }) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse(localStorage.getItem("apiPaths")) : "-"

  console.log("rows ::", rows);

  const [freetext, setFreeText] = useState("-")

  const todayDate = format(new Date(), "yyyy-MM-dd");

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

  console.log("currentUserObject", currentUserObject)

  const userFromUserObjectInLocalStorage = currentUserObject[0].user?.trim();

  const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

  const userAccessGroup = currentUserObject[0].accessgrp;

  const initialFilterObject = {
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_coordinator: userAccessGroup?.trim().toUpperCase() == "COORDINATOR" ? empIDFromUserObjectInLocalStorage : "-",
    task_salesperson: (userAccessGroup?.trim().toUpperCase() != "COORDINATOR" && userAccessGroup?.trim().toUpperCase() != "ADMIN" && userAccessGroup?.trim().toUpperCase() != "CADMIN") ? empIDFromUserObjectInLocalStorage : "-",
    task_creator_id: "-",
    lead_status: "-"
  };

  const [filterSelected, setFilterSelected] = useState(""); // Search term state
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [filteredRows, setFilteredRows] = useState(rows);
  // const [viewMode, setViewMode] = useState("Tabular"); // View mode state
  const [viewMode, setViewMode] = useState("Grouped"); // View mode state
  const [editingRowId, setEditingRowId] = useState(null);
  const newRowRef = useRef();

  const [userDepartment, setUserDepartment] = useState(null);
  const [selectedLeads, setSelectedLeads] = useState([]); // State to track selected leads
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null); // Track selected lead for the modal
  const [showModal, setShowModal] = useState(false); // To control the visibility of the modal
  const [showStatusModal, setShowStatusModal] = useState(false); // To control the visibility of the modal
  const [showDeleteModal, setShowDeleteModal] = useState(false); // To control the visibility of the modal
  const [viewLeadModal, setViewLeadModal] = useState(false);
  // const [checkedLead, setCheckedLead] = useState(''); // State to track selected leads
  const [filteredLeadRows, setFilteredLeadRows] = useState(rows);

  const [contactedLeads, setContactedLeads] = useState(() => {
    const storedContactedLeads = localStorage.getItem("contactedLeads");
    return storedContactedLeads ? JSON.parse(storedContactedLeads) : []; // Use a default empty array
  });

  const [qualifiedLeads, setQualifiedLeads] = useState(() => {
    const storedQualifiedLeads = localStorage.getItem("contactedLeads");

    return storedQualifiedLeads ? JSON.parse(storedQualifiedLeads) : []; // Use a default empty array
  });

  console.log("qualifiedLeads:103", qualifiedLeads);


  const resetLeadFilters = () => {
    setFilteredLeadRows(rows);
  };

  const closeLeadFilter = () => {
    setShowLeadFilter(false);
    // setShowLeadFilter(true)
  };


  useEffect(() => {

    console.log("selectedLeads ", selectedLeads)

  }, [selectedLeads])

  // const addBlankRow = () => {
  //   const newRow = {
  //     id: Date.now(),
  //     lead: "",
  //     status: "newLead",
  //     organization: "",
  //     title: "",
  //     email: "",
  //     phone: "",
  //     notes: "",
  //     probability: "",
  //     leadEntryTime: new Date().toISOString(),
  //   };

  //   setFilteredLeadRows((prev) => [...prev, newRow]);
  //   setEditingRowId(newRow.lead_id); // Set the new row in edit mode
  // };

  const statusMapping = {
    newLead: "New Lead",
    contacted: "Contacted",
    attemptedToContact: "Attempted",
    qualified: "Qualified",
    unQualified: "Unqualified",
  };

  // const handleRowSelect = (id) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
  //   );
  // };

  // Handle row selection/deselection
  const handleRowSelect = (id) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(id)) {
        // Deselect row
        const newSelectedRows = prevSelected.filter((rowId) => rowId !== id);
        if (newSelectedRows.length === 0) {
          setShowModal(false); // Close the modal if no rows are selected
        }
        return newSelectedRows;
      } else {
        // Select row
        const newSelectedRows = [...prevSelected, id];
        setSelectedLead(rows.find((row) => row.lead_id === id)); // Update selected lead for modal
        setShowModal(true); // Show the modal
        return newSelectedRows;
      }
    });
  };

  // Handle "Select All" checkbox toggle
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(rows?.map((row) => row.lead_id)); // Select all rows
      setSelectedLead(rows); // Set all rows to selected for modal
      setShowModal(true); // Show the modal
    } else {
      setSelectedRows([]); // Deselect all rows
      setShowModal(false); // Close the modal
    }
  };

  // Open modal to view and edit the selected lead
  const openModal = (lead) => {
    setSelectedLead(lead); // Set the selected lead in the state
    setShowModal(true); // Show the modal
  };

  const openStatusModal = (lead) => {
    setSelectedLead(lead);
    // console.log("lead 187 open status:", lead);
    setShowStatusModal(true);
  };

  const handleViewLead = (lead) => {
    setSelectedLead(lead);
    console.log("lead 195 handle view:", lead);
    setViewLeadModal(true);
  };

  // Close the modal
  const closeViewLeadModal = () => {
    // console.log("clode lead view modal");
    setViewLeadModal((prev) => !prev);
  };

  // Close the modal
  const closeModal = () => {
    setShowModal(false); // Hide the modal
    setSelectedLead(null); // Reset the selected lead
  };

  const deleteSelectedLeads = () => {
    console.log("inside deleteSelectedLeads");
    const updatedLeads = filteredLeadRows.filter(
      (lead) => !selectedLeads.includes(lead.id)
    );
    setFilteredLeadRows(updatedLeads);
    setRows((prevRows) =>
      prevRows.filter((lead) => !selectedLeads.includes(lead.id))
    );
    setSelectedLeads([]); // Clear selected leads after deletion
    setShowDeleteModal(false); // Close modal after deletion
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false); // Close modal
  };
  const closeStatusModal = () => {
    setShowStatusModal(false);
  };

  const openDeletePopup = (rows) => {
    setShowDeleteModal(true);
  };

  const onDeleteChecked = () => {
    console.log("reached on delete in table 235");
    setShowDeleteModal(true);
  };

  // Handle Delete - Removes selected rows from the list
  const handleDelete = (selectedRows) => {
    // console.log("handleDelete from table", selectedRows);
    // Filter out the selected rows from the 'rows' state
    const updatedRows = rows.filter(
      (row) => !selectedRows.includes(row.lead_id)
    );

    // Update the state and localStorage to reflect the deletion
    setRows(updatedRows);
    localStorage.setItem("rows", JSON.stringify(updatedRows));

    // Close the modal after deletion
    closeModal();
  };

  // Handle Edit - Open an edit form (this is a placeholder function)
  const handleEdit = (rows) => {
    // Implement your edit logic here
    // For example, you could redirect to an edit page or show an edit form
    // console.log("Editing:", rows);
    closeModal(); // Optionally close the modal
  };

  const updateStatusToQualified = (leadId) => {
    // Find the lead to update
    const leadToMove = rows.find((row) => row.lead_id === leadId);

    if (!leadToMove) {
      console.error("Lead not found");
      return;
    }
    // console.log('leadToMove:294 table',leadToMove)

    // Ensure the timeline is properly initialized
    const timeline = Array.isArray(leadToMove.timeline)
      ? leadToMove.timeline
      : [];

    // Create a new timeline entry
    const currentTimestamp = new Date().toISOString();
    const statusChangeTimeline = {
      date: currentTimestamp,
      activity: "Status changed to Qualified",
    };

    // Prepare the updated lead
    const updatedLead = {
      ...leadToMove,
      status: "qualified",
      timeline: [...timeline, statusChangeTimeline],
    };

    // console.log('updatedLead:314 table',updatedLead)

    // Update the list of qualified leads
    setQualifiedLeads((prevQualifiedLeads) => {
      const updatedQualifiedLeads = [...prevQualifiedLeads, updatedLead];
      // console.log('updatedQualifiedLeads 320 table',updatedQualifiedLeads)
      // Save the updated list to localStorage
      // localStorage.setItem(
      //   "qualifiedLeads",
      //   JSON.stringify(updatedQualifiedLeads)
      // );
      return updatedQualifiedLeads;
    });

    // Remove the lead from the current rows list
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((row) => row.lead_id !== leadId);

      // Save the updated rows to localStorage
      localStorage.setItem("rows", JSON.stringify(updatedRows));
      return updatedRows;
    });
    closeStatusModal();
  };
  // showStatusModal(false)

  const updateStatusToContacted = (leadId) => {
    // Find the lead to update
    const leadToMove = rows.find((row) => row.lead_id === leadId);

    if (!leadToMove) return; // Guard against invalid ID

    // Update the lead's status to "Contacted"
    const updatedLead = { ...leadToMove, status: "contacted" };

    // Update the rows and remove the updated lead from the list
    setRows((prevRows) => prevRows.filter((row) => row.lead_id !== leadId));

    // Add the updated lead to the contactedLeads list
    const updatedContactedLeads = [...contactedLeads, updatedLead];
    setContactedLeads(updatedContactedLeads);

    // Save the updated rows and contacted leads to localStorage
    localStorage.setItem(
      "rows",
      JSON.stringify(rows.filter((row) => row.lead_id !== leadId))
    );
    localStorage.setItem(
      "contactedLeads",
      JSON.stringify(updatedContactedLeads)
    );

    setShowStatusModal(false);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setFreeText(term)

    // if (term.trim() === "") {
    //   setFilteredLeadRows(rows); // Reset to all rows
    // } else {
    //   setFilteredLeadRows(
    //     rows.filter((row) => {
    //       const flatRow = Object.values(row)
    //         .map((value) =>
    //           typeof value === "string" ? value : JSON.stringify(value)
    //         )
    //         .join(" ");
    //       return flatRow.toLowerCase().includes(term.toLowerCase());
    //     })
    //   );
    // }
  };

  const updateRow = (id, field, value) => {
    setRows((prevRows) =>
      prevRows?.map((row) =>
        row.lead_id === id ? { ...row, [field]: value } : row
      )
    );
    setFilteredRows((prevRows) =>
      prevRows?.map((row) =>
        row.lead_id === id ? { ...row, [field]: value } : row
      )
    );
  };

  ////////////////////////////////////////////////////////////////

  const getStatusClass = (status) => {
    switch (status) {
      case "newLead":
        return "bg-orange-400";
      case "contacted":
        return "bg-blue-600";
      case "attemptedToContact":
        return "bg-red-400";
      case "qualified":
        return "bg-green-400";
      case "unQualified":
        return "bg-red-600";
      default:
        return "bg-gray-300";
    }
  };

  // Define DataGrid columns
  const columns = [
    {
      field: "select",
      headerName: "",
      sortable: false,
      width: 50,
      renderCell: (params) => (
        <input
          type="checkbox"
          checked={selectedRows.includes(params.row.lead_id)}
          onChange={() => {
            setSelectedRows((prev) =>
              prev.includes(params.row.lead_id)
                ? prev.filter((id) => id !== params.row.lead_id)
                : [...prev, params.row.lead_id]
            );
          }}
        />
      ),
    },
    { field: "lead", headerName: "Lead", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Button
          style={{
            width: "100%",
            color: "white",
            padding: "0.25rem",
            borderRadius: "0.25rem",
          }}
          className={getStatusClass(params.value)}
          onClick={() => console.log("Open Status Modal", params.row)}
        >
          {params.value}
        </Button>
      ),
    },
    { field: "organization", headerName: "Organization", flex: 1 },
    { field: "title", headerName: "Title", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phone", headerName: "Phone", flex: 1 },
    { field: "notes", headerName: "Notes", flex: 1 },
    { field: "probability", headerName: "Probability", flex: 1 },
  ];

  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };

  const [showLeadFilter, setShowLeadFilter] = useState(false);

  const onLeadFilter = () => {
    setShowLeadFilter((prev) => !prev);
  };

  // const openStatusModal = (lead) => {
  //   setSelectedLead(lead);
  //   setShowStatusModal(true);
  // };

  const groupedLeads = filteredLeadRows?.reduce((groups, lead) => {
    const status = lead.lead_status || "Unknown"; // Default to "Unknown" if no status
    if (!groups[status]) {
      groups[status] = [];
    }
    groups[status].push(lead);
    return groups;
  }, {});

  const updateLeadStatus = (leadId, newStatus) => {
    setFilteredLeadRows((prevLeads) =>
      prevLeads.map((lead) =>
        lead.id === leadId ? { ...lead, status: newStatus } : lead
      )
    );
    closeStatusModal(); // Close the modal after updating the status
  };

  const handleInputChange = (id, field, value) => {
    console.log("handleInputChange ...");
    setFilteredLeadRows((prev) =>
      prev.map((row) => (row.lead_id === id ? { ...row, [field]: value } : row))
    );
  };

  useEffect(() => {
    setUserDepartment(localStorage.getItem("currentSelectedDepartment"));
    callLeadListFilter(initialFilterObject);
  }, []);

  console.log("userDepartment", userDepartment);

  const [leadsWithProducts, setLeadsWithProducts] = useState(new Set());

  let currentSelectedDepartment = localStorage.getItem(
    "currentSelectedDepartment"
  );



  const callLeadListFilter = (filterObjectFromModal) => {


    let textToSearch = "-"

    if (freetext?.trim() != "") {
      textToSearch = freetext
    }

    let currentUserEMPID = "-";

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser")
    );

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0]
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0]
      );
    }

    const apiurl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMLeadMainList/${company_code_from_local_storage}/EXqualified/-/-/-/-/${currentSelectedDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${textToSearch}/${filterObjectFromModal.lead_status}/-?task_coordinator=${filterObjectFromModal.task_coordinator}&task_salesperson=${filterObjectFromModal.task_salesperson}&task_creator_id=${currentUserEMPID}`;

    axios
      .get(apiurl)
      .then((res) => {
        setFilteredLeadRows(res.data);
        // console.log("res.data:", res.data);

        // Extract lead IDs with Cnt > 0
        const leadsWithCount = new Set(
          res.data.filter((lead) => lead.Cnt > 0).map((lead) => lead.lead_id)
        );

        // console.log("Leads with products:", leadsWithCount);
        setLeadsWithProducts(leadsWithCount);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };

  useEffect(() => {

    callLeadListFilter(initialFilterObject)
  }, [freetext])

  console.log("filteredLeadRows:", filteredLeadRows);
  const [addLeadButton, setAddLeadButton] = useState(true);

  const handleGroupedClick = () => {
    setViewMode("Grouped");
    setAddLeadButton(true);
  };

  const handleNormalClick = () => {
    setViewMode("Normal");
    setAddLeadButton(true);
  };

  const handleKanbanClick = () => {
    setViewMode("Kanban");
    setAddLeadButton(false);
  };

  const handleFilterUpdate = (filterData) => {
    setFilterSelected(filterData);
    console.log("Updated Filters:", filterData);
  };

  const deleteLead = () => {

    // selectedLeads

    let rowsToDelete = selectedLeads?.map((item) => {
      return (
        {
          "CmpCode": company_code_from_local_storage,
          "mode": "LEAD",
          "DocuNo": item,
          "deptno": currentSelectedDepartment,
          "user": userFromUserObjectInLocalStorage
        }
      )
    })



     let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocuDelete`

     const jsonToSend = JSON.stringify(rowsToDelete);

     console.log("jsonToSend ", jsonToSend)

    axios.post(apiUrl, jsonToSend ,{
      headers: {
        "Content-Type": "application/json",
      }
    }).then((res) => {

      if(res.data.result == "Saved"){
        setShowDeleteModal(false)
        callLeadListFilter(initialFilterObject);
      }

    }).catch((err) => {

      alert("something went wrong, please try later")
    })

  }

  return (
    <div className="mx-2">
      {/* <h2 className="text-xl   mb-4">Leads Table</h2> */}
      <div className="flex items-center justify-between gap-6 text-center p-2  ">
        {/* <h2 className="text-xl font-normal   mb-4">Leads</h2> */}
        <div className="flex items-center gap-6  ">
          <h2 className="text-xl font-normal   mb-1">Leads</h2>

          {addLeadButton && (
            <div className="flex justify-center items-center gap-4">
              <button
                onClick={() => setValue("2")}
                className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
              >
                Add Lead
              </button>

              {/* Search Bar */}
              <div className="relative flex justify-end my-2 ">
                <input
                  type="text"
                  className=" py-2 pl-10 pr-4 rounded-lg  text-black placeholder-gray-400 border border-none shadow-sm bg-white w-full"
                  placeholder="Search Leads..."
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                />

                {/* Search Icon */}
                <div className="absolute left-3  top-1/2 transform -translate-y-1/2 ">
                  <AiOutlineSearch className="text-gray-500" />
                </div>

                {/* Clear Icon */}
                {searchTerm && (
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => handleSearch("")} // Clear the search term when clicked
                  >
                    <AiOutlineClose className="text-gray-500" />
                  </div>
                )}
              </div>

              {/* filter button  */}
              <button
                className="shadow-sm flex items-center space-x-2 p-1 border border-none rounded-full bg-white hover:bg-gray-100 "
                style={{
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                // onClick={() =>
                //   document.getElementById("filterModal").classList.remove("hidden")
                // }
                onClick={onLeadFilter}
              >
                <img
                  src={filter}
                  alt="filter-icon"
                  className="w-6 h-6 "
                  style={{ width: "16px", objectFit: "contain" }}
                />
                {/* <span className="text-sm text-gray-600">Filter</span> */}
              </button>
            </div>
          )}
        </div>

        <ButtonGroup
          variant="outlined"
          sx={{
            backgroundColor: "white",

            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)", // shadow-sm equivalent
            "& .MuiButton-outlined": {
              border: "none", // Removes the outline
            },
          }}
        >
          <Button
            onClick={handleGroupedClick}
            sx={{
              // backgroundColor: viewMode === "Grouped" ? "#E0F7FA" : "white", // Light blue for selected
              backgroundColor: viewMode === "transparent", // Light blue for selected
              "& img": {
                filter:
                  viewMode === "Grouped"
                    ? "invert(29%) sepia(98%) saturate(2942%) hue-rotate(202deg) brightness(95%) contrast(92%)"
                    : "none", // Blue color for selected
              },
            }}
          >
            <img src={group} alt="grouped-icon" className="w-6 h-6" />
          </Button>
          <Button
            onClick={handleNormalClick}
            sx={{
              // backgroundColor: viewMode === "Normal" ? "#E0F7FA" : "white", // Light blue for selected
              backgroundColor: viewMode === "transparent", // Light blue for selected
              "& img": {
                filter:
                  viewMode === "Normal"
                    ? "invert(29%) sepia(98%) saturate(2942%) hue-rotate(202deg) brightness(95%) contrast(92%)"
                    : "none", // Blue color for selected
              },
            }}
          >
            <img src={table} alt="normal-table-icon" className="w-6 h-6" />
          </Button>

          <Button
            onClick={handleKanbanClick}
            sx={{
              backgroundColor: viewMode === "transparent", // Light blue for selected
              "& img": {
                filter:
                  viewMode === "Kanban"
                    ? "invert(29%) sepia(98%) saturate(2942%) hue-rotate(202deg) brightness(95%) contrast(92%)"
                    : "none", // Blue color for selected
              },
            }}
          >
            <img src={kanban} alt="kanban-icon" className="w-6 h-6" />
          </Button>
        </ButtonGroup>
      </div>

      {viewMode === "Kanban" ? (
        <KanbanViewLeads
          handleInputChange={handleInputChange}
          rows={filteredLeadRows}
          setRows={setFilteredLeadRows}
          groupedRows={groupedRows}
          onDeleteChecked={onDeleteChecked}
          onEditLead={onEditLead}
          viewLeadModal={viewLeadModal}

          clickedOnEditLead={clickedOnEditLead}
        />
      ) : //  {viewLeadModal && (
        //   <ViewLead selectedLead={selectedLead} onClose={closeViewLeadModal} onEditLead={onEditLead} />
        // )}
        viewMode === "Grouped" ? (
          <TableGrouped
            groupedLeads={groupedLeads}
            statusMapping={statusMapping}
            setSelectedLeads={setSelectedLeads}
            selectedLeads={selectedLeads}
            handleViewLead={handleViewLead}
            calculateAgedDays={calculateAgedDays}
            openStatusModal={openStatusModal}
            onDeleteChecked={onDeleteChecked}
            handleInputChange={handleInputChange}
            editingRowId={editingRowId}
            setEditingRowId={setEditingRowId}
            leadsWithProducts={leadsWithProducts}
            clickedOnEditLead={clickedOnEditLead}
          />
        ) : (
          <div>
            {/* <ContactedLeads rows={rows} setRows={setRows} /> */}
            {selectedLeads.length > 0 && (
              <div className="mb-2">
                <button
                  // onClick={() => setShowDeleteModal(true)}
                  onClick={onDeleteChecked}
                  className="bg-red-500 text-white px-2 py-2 rounded mr-2"
                  disabled={selectedLeads.length === 0}
                >
                  {/* Delete Selected */}
                  {/* <img src={deleteIcon} alt="delete-icon" className="w-3 h-3 text-white" /> */}
                  <AiFillDelete size={18} />
                </button>
              </div>
            )}
            <div className="overflow-x-hidden max-w-full mt-2  max-h-[60vh] overflow-y-auto scrollbar-thin">
              <table className="table-auto w-[100%] border-collapse border border-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="shadow-sm px-1 py-0.5 text-left">
                      <input
                        type="checkbox"
                        className="rounded border border-sm shadow"
                        onChange={(e) =>
                          setSelectedLeads(
                            e.target.checked
                              ? filteredLeadRows.map((row) => row.lead_id)
                              : []
                          )
                        }
                        checked={
                          selectedLeads.length > 0 &&
                          selectedLeads.length === filteredLeadRows.length
                        }
                      />
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Organization/Customer
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Status
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Contact Person
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Title
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Email
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Phone
                    </th>
                    <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                      Notes
                    </th>
                    <th className="shadow-sm px-1 py-0.5 w-[50px] text-left font-normal">
                      Probability
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white px-2">
                  {filteredLeadRows.map((row) => (
                    <tr
                      key={row.lead_id}
                      ref={row.lead_id === editingRowId ? newRowRef : null}
                      className={` ${selectedLeads.includes(row.lead_id) ? "bg-blue-100" : ""
                        }`}
                    >
                      <td className="shadow-sm px-1 py-0.5 text-center">
                        <div className="flex justify-between items-center gap-0">
                          <input
                            type="checkbox"
                            className="rounded border border-sm"
                            checked={selectedLeads.includes(row.lead_id)}
                            onChange={() =>
                              setSelectedLeads((prev) =>
                                prev.includes(row.lead_id)
                                  ? prev.filter((id) => id !== row.lead_id)
                                  : [...prev, row.lead_id]
                              )
                            }
                          />

                          {leadsWithProducts.has(row.lead_id) && (
                            <div className="w-1 h-1 bg-green-500 text-xs p-1 rounded-lg"></div>
                          )}
                        </div>
                      </td>

                      <td className="shadow-sm px-1 py-0.5 ">
                        <div className="flex items-center justify-between  ">
                          <input
                            type="text"
                            // value={row.lead_primarycontact}
                            value={row.lead_organization}
                            onChange={(e) =>
                              handleInputChange(
                                row.lead_id,
                                "lead",
                                e.target.value
                              )
                            }
                            autoFocus={row.lead_id === editingRowId}
                            className=" outline-none w-[auto] p-0 border-none text-sm bg-transparent"
                          />

                          <div className="flex items-center  justify-center gap-2">
                            <img
                              onClick={() => handleViewLead(row)}
                              src={expand}
                              alt="expand-icon"
                              className="w-4 h-4 cursor-pointer"
                            />
                            <div className="text-xs font-thin bg-gray-400 px-0.5 rounded-lg text-white w-auto">
                              {calculateAgedDays(row.lead_entryTime)}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td
                        className="shadow-sm px-1 py-0.5 cursor-pointer"
                        onClick={() => openStatusModal(row)}
                      >
                        {row.lead_status && (
                          <button
                            // onClick={() => updateStatusToQualified(row.lead_id)}
                            className={`w-full text-white text-center p-1 rounded ${row.lead_status === "newLead"
                              ? "bg-orange-400"
                              : row.lead_status === "contacted"
                                ? "bg-blue-600"
                                : row.lead_status === "attemptedToContact"
                                  ? "bg-red-400"
                                  : row.lead_status === "qualified"
                                    ? // : row.lead_status === "Qualified"
                                    "bg-green-400"
                                    : row.lead_status === "unQualified"
                                      ? "bg-red-600"
                                      : "bg-gray-300" // default case if no match
                              }`}
                          >
                            {statusMapping[row.lead_status] || row.lead_status}{" "}
                          </button>
                        )}
                      </td>

                      <td className="shadow-sm px-1 py-0.5">
                        <input
                          type="text"
                          value={row.lead_primarycontact}
                          // value={row.lead_organization}
                          onChange={(e) =>
                            handleInputChange(
                              row.lead_id,
                              "organization",
                              e.target.value
                            )
                          }
                          className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                        />
                      </td>

                      <td className="shadow-sm px-1 py-0.5">
                        <input
                          type="text"
                          value={row.lead_primarycontacttitle}
                          onChange={(e) =>
                            handleInputChange(
                              row.lead_id,
                              "title",
                              e.target.value
                            )
                          }
                          className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                        />
                      </td>

                      <td className="shadow-sm px-1 py-0.5">
                        <input
                          type="email"
                          value={row.lead_email}
                          onChange={(e) =>
                            handleInputChange(
                              row.lead_id,
                              "email",
                              e.target.value
                            )
                          }
                          className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                        />
                      </td>

                      <td className="shadow-sm px-1 py-0.5">
                        <input
                          type="text"
                          value={row.lead_phone}
                          onChange={(e) =>
                            handleInputChange(
                              row.lead_id,
                              "phone",
                              e.target.value
                            )
                          }
                          className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                        />
                      </td>

                      <td className="shadow-sm px-1 py-0.5">
                        <input
                          type="text"
                          value={row.lead_notes}
                          onChange={(e) =>
                            handleInputChange(
                              row.lead_id,
                              "notes",
                              e.target.value
                            )
                          }
                          className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                        />
                      </td>

                      <td className="shadow-sm px-1 py-0.5 ">
                        <input
                          type="text"
                          value={row.lead_probability}
                          onChange={(e) =>
                            handleInputChange(
                              row.lead_id,
                              "probability",
                              e.target.value
                            )
                          }
                          className="bg-transparent outline-none w-full block p-0 border-none text-sm text-center"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {/* Filter Modal */}
      {showLeadFilter && (
        <LeadFilterModal
          clearAllFilters={handleFilterUpdate}
          resetFilters={resetLeadFilters}
          callLeadListFilter={callLeadListFilter}
          rows={rows}
          closeFilter={closeLeadFilter}
        />
      )}

      {showModal && selectedLead && (
        <LeadSelectModal
          closeModal={closeModal}
          selectedRows={selectedRows}
          selectedLead={selectedLead}
          openDeletePopup={openDeletePopup}
          handleEdit={handleEdit}
        // handleViewLead={handleViewLead}
        />
      )}

      {/* Modal for deleting lead  */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center relative">
            {/* Image Section */}
            <div className="flex justify-center mb-2">
              <img
                src={delete_Vector}
                alt="Delete Icon"
                className="w-1/4 h-auto max-w-xs"
              />
            </div>

            {/* Close Button */}
            <button
              className="absolute top-6 right-8 text-gray-500 hover:text-black"
              onClick={closeDeleteModal}
            >
              ✖
            </button>

            {/* Title Section */}
            <div className="text-xl font-semibold text-black">
              {selectedLeads.length === 1 ? "Lead Selected" : "Leads Selected"}
            </div>
            <div className="text-gray-700 mb-6">
              {/* Display different message based on the number of selected rows */}
              {selectedLeads.length === 1 ? (
                <span className="font-bold">
                  {/* Are you sure you want to delete {checkedLead}{" "} */}
                  Are you sure you want to delete {selectedLeads.lead}?
                </span>
              ) : (
                <span className="font-bold">
                  Are you sure you want to delete {selectedLeads.length} leads?
                </span>
              )}
            </div>

            {/* Action Buttons */}
            <div className="flex justify-center space-x-4">
              {/* Delete Button */}
              <button
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                onClick={deleteLead} // Call delete function
              >
                Delete
              </button>

              {/* Cancel Button */}
              <button
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                onClick={closeDeleteModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Dialog for selecting lead status */}
      {showStatusModal && (
        <LeadStatusModal
          showStatusModal={showStatusModal}
          closeStatusModal={closeStatusModal}
          updateStatusToContacted={updateStatusToContacted}
          updateStatusToQualified={updateStatusToQualified}
          selectedLeadId={selectedLead.id}
          selectedLead={selectedLead}
          updateLeadStatus={updateLeadStatus}
        />
      )}
      {viewLeadModal && (
        <ViewLead
          selectedLead={selectedLead}
          onClose={closeViewLeadModal}
          onEditLeadFromViewLead={onEditLeadFromViewLead}
          clickedOnEditLead={clickedOnEditLead}
        />
      )}
    </div>
  );
};

export default TableComponent;
